import { Reveal } from "./Reveal";
import { WavyUnderline, SunDoodle, Bee, FlowerDoodle } from "./Doodles";

export default function PageHero({ eyebrow, title, sub, doodle = "sun" }) {
    return (
        <section className="relative pt-28 md:pt-36 pb-12 md:pb-16 overflow-x-clip">
            <div aria-hidden="true" className="absolute -top-10 right-0 w-[260px] h-[260px] sm:w-[420px] sm:h-[420px] rounded-full bg-sage/10 blur-3xl" />
            <div aria-hidden="true" className="absolute top-48 -left-20 w-[200px] h-[200px] sm:top-40 sm:-left-24 sm:w-[320px] sm:h-[320px] rounded-full bg-skysoft blur-2xl opacity-50 sm:opacity-100" />
            {doodle === "sun" && <SunDoodle className="absolute top-24 right-6 md:right-14 opacity-90 hidden sm:block" />}
            {doodle === "bee" && <Bee className="absolute top-28 right-8 md:right-20 hidden sm:block" />}

            <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
                <Reveal>
                    {eyebrow && (
                        <p className="inline-flex items-center gap-2 bg-white/80 border-2 border-soil/10 rounded-full px-4 py-1.5 text-sm font-extrabold text-sageink mb-5">
                            <FlowerDoodle size={16} />
                            {eyebrow}
                        </p>
                    )}
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-soil max-w-3xl text-balance">
                        {title}
                        <WavyUnderline className="block w-44 md:w-56 h-3 mt-3" />
                    </h1>
                </Reveal>
                {sub && (
                    <Reveal delay={0.16}>
                        <p className="mt-5 text-base sm:text-lg text-soilmuted max-w-2xl leading-relaxed">{sub}</p>
                    </Reveal>
                )}
            </div>
        </section>
    );
}
